export const BLOCK_OPEN_PREFIX = '#';

export const BLOCK_CLOSE_PREFIX = '/';

export const PARTIAL_PATH_PREFIX = '>';

export const PARTIAL_BLOCK_PATH_PREFIX = `${BLOCK_OPEN_PREFIX}${PARTIAL_PATH_PREFIX}`;

export const INVERSE_BLOCK_PATH = 'else';

export const COMMENT_PREFIX = '!--';

export const COMMENT_SUFFIX = '--';
